import { ConversionBarTwoRailsActionsRow } from '../shared/ConversionBarTwoRailsActionsRow';
import { ConversionBarTwoRailsEventMeta } from '../shared/ConversionBarTwoRailsEventMeta';

import { ExternalTicketsPanelCta } from './ExternalTicketsPanelCta';
import { ExternalTicketsPanelHeadline } from './ExternalTicketsPanelHeadline';
import styles from './ExternalTicketsPanel.module.scss';

export const ExternalTicketsTwoRailsPanel: React.FC = () => (
  <>
    <ConversionBarTwoRailsEventMeta />
    <ConversionBarTwoRailsActionsRow
      leading={<ExternalTicketsPanelHeadline />}
      cta={<ExternalTicketsPanelCta wrapperClassName={styles.twoRailsCtaButtonWrapper} />}
    />
  </>
);
